<template>
  <div class="read-detail container">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/read/list' }">阅读资料</el-breadcrumb-item>
        <el-breadcrumb-item>资料详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="status">
            <span class="label">发布状态：</span>
            <el-switch v-model="read.status"
                       @change="updateReadInfo"></el-switch>
          </div>
        </div>
        <div class="right">
          <el-button type="primary"
                     @click="handleToPreview">预览</el-button>
        </div>
      </div>
    </div>
    <ReadInfo class="info-card"
              :content="read"
              @submit="fetchReadInfo"
              @refurse="refurse" />
    <div class="main">
      <div class="tabs">
        <div :class="{ 'tab-item': true, active: tabKey == 'chapter' }"
             @click="handleTabChange('chapter')">
          资料列表
        </div>
        <el-divider direction="vertical"></el-divider>
        <div :class="{ 'tab-item': true, active: tabKey == 'comment' }"
             @click="handleTabChange('comment')">
          产品评价
        </div>
      </div>
      <Comment v-if="tabKey == 'comment'"></Comment>
      <template v-if="tabKey == 'chapter'">
        <div class="card-header">
          <h3 class="title"></h3>

          <el-button type="primary"
                     @click="handleChapterAdd">添加一级章节</el-button>
        </div>
        <div class="table-wrap">
          <el-table ref="table"
                    :data="results"
                    style="width: 100%"
                    row-key="id"
                    :default-expand-all="false"
                    :expand-row-keys="expands"
                    row-class-name="row-item"
                    :tree-props="{ children: 'children' }">
            <el-table-column class-name="title-cell"
                             prop="name"
                             label="章节"
                             width="300">
              <template slot-scope="scope">
                <input class="input"
                       v-model="scope.row.name"
                       v-focus="scope.row.id == insertId"
                       placeholder="请输入章节标题"
                       @blur="handleTitleChange(scope.row, $event)" />
              </template>
            </el-table-column>
            <el-table-column prop="item_count"
                             label="总知识点数"
                             width="100"
                             align="center">
            </el-table-column>
            <el-table-column prop="status"
                             label="在线状态"
                             width="110"
                             align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status"
                        type="success">已发布</el-tag>
                <el-tag v-if="!scope.row.status"
                        type="warning">未发布</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="status"
                             label="来源状态"
                             width="110"
                             align="center">
              <template slot-scope="scope">
                <el-tag :type="
                    scope.row.create_type == 2
                      ? 'warning'
                      : scope.row.create_type == 1
                      ? 'success'
                      : ''
                  ">
                  {{
                    scope.row.create_type == 1
                      ? "新建"
                      : scope.row.create_type == 2
                      ? "关联"
                      : "复制"
                  }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="trial"
                             label="试用状态"
                             width="110"
                             align="center">
              <template v-if="scope.row.level !== 1"
                        slot-scope="scope">
                <el-tag v-if="scope.row.trial"
                        type="success">可试用</el-tag>
                <el-tag v-if="!scope.row.trial"
                        type="warning">不可试用</el-tag>
              </template>
            </el-table-column>
            <el-table-column class-name="edit-cell"
                             label="编辑"
                             align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.level === 1">
                  <el-button type="text"
                             @click="handleSubChapterAdd(scope.row)">添加子级</el-button>
                  <el-divider direction="vertical"></el-divider>
                  <el-button type="text"
                             v-if="scope.row.status == false"
                             @click="handleStatusChange(scope.row, true)">发布</el-button>
                  <el-button type="text"
                             v-if="scope.row.status"
                             @click="handleStatusChange(scope.row, false)">下线</el-button>
                </div>
                <div v-if="scope.row.level !== 1">
                  <el-button type="text"
                             v-if="scope.row.trial == false"
                             @click="handFreeChange(scope.row, true)">允许试用</el-button>
                  <el-button type="text"
                             v-if="scope.row.trial"
                             @click="handFreeChange(scope.row, false)">禁止试用</el-button>
                  <el-divider direction="vertical"></el-divider>
                  <el-button type="text"
                             @click="handleChapterToEdit(scope.row)">编辑知识点</el-button>
                  <el-divider direction="vertical"></el-divider>
                  <el-button type="text"
                             v-if="scope.row.status == false"
                             @click="handleStatusChange(scope.row, true)">发布</el-button>
                  <el-button type="text"
                             v-if="scope.row.status"
                             @click="handleStatusChange(scope.row, false)">下线</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column class-name="action-cell"
                             label="操作"
                             width="140"
                             align="center">
              <template slot-scope="scope">
                <div class="menu-wrap"
                     v-if="scope.row.level === 1">
                  <div v-if="handleActionCheck(scope.row, 'up')">
                    <el-button type="text"
                               @click="handleSortChange(scope.row, 'up')">上移</el-button>
                    <el-divider direction="vertical"></el-divider>
                  </div>
                  <div v-if="handleActionCheck(scope.row, 'down')">
                    <el-button type="text"
                               @click="handleSortChange(scope.row, 'down')">下移</el-button>
                    <el-divider direction="vertical"></el-divider>
                  </div>
                  <div>
                    <el-button type="text"
                               @click="handleRemoveChapter(scope.row)">删除</el-button>
                  </div>
                </div>
                <div class="menu-wrap"
                     v-if="scope.row.level !== 1">
                  <div v-if="handleActionCheck(scope.row, 'up')">
                    <el-button type="text"
                               @click="handleSortChange(scope.row, 'up')">上移</el-button>
                    <el-divider direction="vertical"></el-divider>
                  </div>
                  <div v-if="handleActionCheck(scope.row, 'down')">
                    <el-button type="text"
                               @click="handleSortChange(scope.row, 'down')">下移</el-button>
                    <el-divider direction="vertical"></el-divider>
                  </div>
                  <div>
                    <el-button type="text"
                               @click="handleRemoveChapter(scope.row)">删除</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <AddChildLevel @submit="fetchReadChapterList()"
                   ref="addChildLevel"
                   @addNewChild="addNewChild"></AddChildLevel>
  </div>
</template>

<script>
import ReadInfo from '@/components/card/ReadInfo'
import {
  readOne,
  readUpdateStatus,
  readChapterList,
  readChapterCreate,
  readChapterUpdate,
  readChaptersUpdate,
  readChapterDestroy,
} from '@/api/read'
import Comment from './readComment'
import AddChildLevel from '@/components/read/AddChildLevel.vue'

export default {
  components: {
    ReadInfo,
    Comment,
    AddChildLevel,
  },
  data() {
    return {
      expands: [],
      insertId: '',
      read: {},
      results: [],
      tabKey: 'chapter',
      childLevelItem: {},
    }
  },
  created() {
    this.fetchReadInfo()
    this.fetchReadChapterList()
    this.$store.dispatch('getAllColleges')
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    refurse() {
      this.fetchReadInfo()
    },
    // 阅读资料基本信息
    fetchReadInfo() {
      readOne({ id: this.$route.params.readId }).then((res) => {
        this.read = res
        this.read.status = this.read.status == 1 ? true : false
      })
    },
    // 更新阅读资料在线状态
    updateReadInfo() {
      readUpdateStatus({
        id: this.$route.params.readId,
        status: this.read.status ? 1 : 0,
      })
        .then((res) => {
          this.$message.success(`发布状态更新成功`)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    // 阅读资料章节列表请求
    fetchReadChapterList() {
      readChapterList({ product_id: this.$route.params.readId }).then((res) => {
        this.results = res.list || []
        setTimeout(() => {
          this.results.length && this.hendleToggleExpand(this.results[0], true)
        }, 100)
      })
    },
    // 页面滚动到顶部
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    // 试用状态变更
    handFreeChange(row, trial) {
      row.trial = trial
      readChapterUpdate({ id: row.id, trial: row.trial ? 1 : 0 })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('试用状态更新异常')
          console.log('error: ', error)
        })
    },
    // 发布状态变化
    handleStatusChange(row, status) {
      row.status = status
      readChapterUpdate({ id: row.id, status: row.status ? 1 : 0 })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('在线状态更新异常')
          console.log('error: ', error)
        })
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      let { index, list } = this.computeIndex(row.id)
      let item = list.splice(index, 1)[0]
      if (sort == 'up') {
        list.splice(index - 1, 0, item)
      } else if (sort == 'down') {
        list.splice(index + 1, 0, item)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      readChaptersUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节排序更新异常')
          console.log('error: ', error)
        })
    },
    // 删除章节
    handleRemoveChapter(row) {
      let { index, list } = this.computeIndex(row.id)
      if (row.children && row.children.length) {
        return this.$message.error('请清除子节点后再进行删除操作')
      }
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          readChapterDestroy({ id: row.id }).then((res) => {
            list.splice(index, 1)[0]
          })
        })
        .catch((error) => {
          this.$message.error('章节删除失败')
          console.log('error: ', error)
        })
    },
    // 数据位置计算
    computeIndex(id) {
      let index = null
      let length = 0
      let list = []
      this.results.some((item, i, arr) => {
        if (item.id == id) {
          index = i
          length = this.results.length
          list = arr
          return true
        }
        if (item.children) {
          item.children.some((subItem, subIndex, subArr) => {
            if (subItem.id == id) {
              index = subIndex
              length = item.children.length
              list = subArr
              return true
            }
          })
        }
      })
      return { index, length, list }
    },
    // 排序边界检查
    handleActionCheck(row, type) {
      let { index, length } = this.computeIndex(row.id)
      if (type == 'up') {
        if (index === 0) {
          return false
        }
        if (index > 0 && length > 1) {
          return true
        }
      }
      if (type == 'down') {
        if (index === length - 1) {
          return false
        }
        return true
      }
      return false
    },
    // 章节标题变化
    handleTitleChange(row) {
      readChapterUpdate({ id: row.id, name: row.name })
        .then((res) => {
          this.insertId = ''
        })
        .catch((error) => {
          this.$message.error('章节标题更新异常')
          console.log('error: ', error)
        })
    },
    // 章节试卷编辑
    handleChapterToEdit(row) {
      this.$router.push(
        `/read/detail/${this.$route.params.readId}/chapter/${row.id}`
      )
    },
    // 添加章
    handleChapterAdd() {
      let newChapter = {
        product_id: this.$route.params.readId,
        name: '',
        level: 1,
        status: 0,
      }
      readChapterCreate(newChapter)
        .then((res) => {
          this.insertId = res.id
          res.children = []
          this.results.push(res)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },

    addNewChild() {
      let row = this.childLevelItem
      this.results.forEach((item) => {
        if (item.id != row.id) {
          this.hendleToggleExpand(item, false)
        }
      })

      let newChapter = {
        product_id: this.$route.params.readId,
        pid: row.id,
        name: '',
        level: row.level + 1,
        status: 0,
      }
      readChapterCreate(newChapter)
        .then((res) => {
          this.insertId = res.id
          let { index } = this.computeIndex(row.id)

          // 稍晚一点儿展开行
          if (row.children.length) {
            this.hendleToggleExpand(row)
          } else {
            setTimeout(() => {
              this.hendleToggleExpand(row)
            }, 20)
          }

          if (this.results[index].id == row.id) {
            this.results[index].children.push(res)
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },

    // 添加节
    handleSubChapterAdd(row) {
      this.childLevelItem = row
      this.$refs.addChildLevel.open(row.id)
    },
    // table row 展开状态变化
    hendleToggleExpand(row, expanded = true) {
      this.$refs.table.toggleRowExpansion(row, expanded)
    },
    // 预览
    handleToPreview() {
      if (location.host.includes('admin.kaoyanbox.com')) {
        window.open(`https://h5.kaoyanbox.com/read/detail/${this.read.id}`)
      } else {
        window.open(`https://h5.kaoyanbox.net/read/detail/${this.read.id}`)
      }
    },
    handleTabChange(key) {
      this.tabKey = key
    },
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
      update: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
    },
  },
}
</script>

<style scoped lang="less">
.read-detail {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .info-card {
    margin-top: 10px;
  }
  .main {
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    padding: 20px;
    overflow: hidden;
    margin-top: 10px;
    position: relative;
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .tabs {
      position: absolute;
      left: 20px;
      top: 20px;
      height: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tab-item {
        font-size: 14px;
        cursor: pointer;

        &.active {
          font-size: 16px;
          font-weight: bold;
          cursor: default;
        }
      }
    }
  }
  .table-wrap {
    /deep/ .title-cell {
      width: 50px;

      .cell {
        display: flex;
        align-items: center;
      }
      .input {
        width: 250px;
        height: 32px;
        line-height: 32px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 4px;
        color: #606266;
        padding: 0 15px;
        outline: 0;

        &:focus {
          background: #fff;
          border-color: #409eff !important;
        }
      }

      &:hover .input {
        background: #fff;
        border-color: #dcdfe6;
      }
    }
    /deep/ .action-cell {
      .el-divider--vertical {
        margin: 0 4px;
      }
    }

    /deep/ .row-item {
      &:hover .menu-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .menu-wrap {
        display: none;
      }
    }
  }
}
</style>
